<template>
  <div class="cls-page">
    <van-nav-bar title="我的班级" left-arrow @click-left="goBack" fixed placeholder />

    <div class="banner">
      <div class="banner-icon">
        <van-icon name="friends" />
      </div>
      <div class="banner-text">
        <div class="banner-title">班级管理</div>
        <div class="banner-sub">选择班级，查看学生与考勤</div>
      </div>
    </div>

    <div class="cls-list" v-if="list.length > 0">
      <div class="cls-item" v-for="item in list" :key="item.id">
        <div class="item-main" @click="onTap(item)">
          <div class="item-badge">
            <van-icon name="friends-o" />
          </div>
          <div class="item-info">
            <div class="item-name-row">
              <span class="item-name">{{ item.class_name }}</span>
              <!-- <span class="grade-tag">{{ item.grade }}</span> -->
            </div>
            <div class="item-tip">
              <van-icon name="arrow" class="tip-arrow" />
              点击进入班级管理
            </div>
          </div>
        </div>
        <div class="item-actions">
          <van-button class="attend-btn" size="small" @click.stop="toAttend(item)">
            <van-icon name="calendar-o" />
            查看考勤
          </van-button>
          <van-icon name="arrow" class="row-arrow" color="#c7c7cc" @click="onTap(item)" />
        </div>
      </div>
    </div>

    <van-empty v-else description="暂无负责班级" />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { Toast } from "vant";
import api from "../service/api";

export default {
  setup() {
    const router = useRouter();
    const list = ref([]);

    const load = async () => {
      try {
        Toast.loading({ message: "加载中...", forbidClick: true });
        const res = await api.getManageClassList({
          sid: localStorage.getItem("sid"),
          teacher_id: sessionStorage.getItem("userId"),
        });
        Toast.clear();
        if (res.data.code == 1001) {
          list.value = res.data.result || [];
        } else {
          Toast(res.data.message);
        }
      } catch (error) {
        Toast.clear();
        Toast("获取班级列表失败");
      }
    };

    const fmtDate = (d) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    };

    const onTap = (item) => {
      router.push({
        path: "/classStudents",
        query: {
          classId: item.id,
          className: item.class_name,
        },
      });
    };

    // 入口：班级行「考勤」按钮 → 本班当日考勤汇总页
    const toAttend = (item) => {
      router.push({
        path: "/classAttendSummary",
        query: {
          classId: item.id,
          className: item.class_name,
          date: fmtDate(new Date()),
        },
      });
    };

    const goBack = () => router.back();

    onMounted(() => {
      load();
    });

    return {
      list,
      onTap,
      toAttend,
      goBack,
    };
  },
};
</script>

<style lang="less" scoped>
.cls-page {
  min-height: 100vh;
  padding-bottom: 20px;
  background: #f5f6f8;
}

/* 顶部渐变横幅 */
.banner {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px;
  padding: 16px;
  border-radius: 14px;
  color: #fff;
  background: linear-gradient(135deg, #52c1b2 0%, #2f8f83 100%);
  box-shadow: 0 6px 16px rgba(47, 143, 131, 0.28);
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
  }

  &::before {
    right: -30px;
    top: -30px;
    width: 110px;
    height: 110px;
  }

  &::after {
    right: 34px;
    bottom: -46px;
    width: 90px;
    height: 90px;
  }
}

.banner-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.22);
  font-size: 24px;
  flex-shrink: 0;
}

.banner-text {
  position: relative;
  z-index: 1;
}

.banner-title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
}

.banner-sub {
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.9;
}

/* 班级列表 */
.cls-list {
  padding: 6px 14px 14px;
}

.cls-item {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  padding: 18px 16px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(31, 35, 41, 0.05);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:active {
    transform: scale(0.985);
    box-shadow: 0 1px 4px rgba(31, 35, 41, 0.08);
  }
}

.item-main {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  cursor: pointer;
}

/* 左侧徽章 */
.item-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  color: var(--color-primary);
  background: linear-gradient(135deg, #e8f8f6 0%, #d2f0ec 100%);
  font-size: 28px;
  flex-shrink: 0;
}

.item-info {
  min-width: 0;
}

.item-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.item-name {
  font-size: 15px;
  font-weight: 600;
  color: #1f2329;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.grade-tag {
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-primary);
  background: var(--color-primary-light);
}

.item-tip {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-top: 8px;
  font-size: 12px;
  color: #a0a6ad;
}

.tip-arrow {
  font-size: 12px;
}

.item-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 10px;
}

.row-arrow {
  font-size: 20px;
}

.attend-btn.van-button {
  flex-shrink: 0;
  height: 34px;
  padding: 0 18px;
  border: none;
  border-radius: 17px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(135deg, #52c1b2 0%, #3aa89a 100%);
  box-shadow: 0 2px 8px rgba(58, 168, 154, 0.32);

  &::before {
    display: none;
  }

  .van-button__content {
    gap: 4px;
  }

  .van-icon {
    font-size: 16px;
  }

  &:active {
    opacity: 0.85;
  }
}
</style>
